
import { Path } from '@/main/router/routerPath';

import { NAME, CRUMB_LABEL_KEY } from './constants';
import SelectList from './List.vue';

export const router = new Path(NAME, { SelectList }, CRUMB_LABEL_KEY);
